import { analogJump, isAndroidOrIos, substring } from '@/utils/index'
import { umtrack } from '@/utils/uweb'
/**
 * 
 * @param {int} type 0 路由跳转 1 打开新页
 * @param {*} path 
 * @param {*} query 
 */
export function openWindow (type, path, query, self) {
  if(type === 0){
    analogJump(path, query, true)
  }else{
    analogJump(path, '', false)
  }
}

export function cblockItem(item, self){
  umtrack('itemClick', { id: item.id, title: item.title }, self)
  if (item.redirect) {
    if (item.urltype == 0) {
      openWindow(1,item.redirect,'', self)
    }else{
      openWindow(0,item.redirect,'', self)
    }
  } else {
    openWindow(0,'/play',{id: item.album}, self)
  }
}

// app jssdk
export function isApp(){
  const os = isAndroidOrIos();
  if (os == 'android'&& 
    window.hasOwnProperty('android') && 
    (typeof(eval(window.android.getAppInfo))=="function" || typeof(eval(window.android.startAdPlay))=="function")
    ){
    return true
  }
  if (os == 'ios' && window.webkit && 
    (window.webkit.messageHandlers.getAppInfo || window.webkit.messageHandlers.startAdPlay)){
    return true
  }
  return false
}
/**
 * 获取Appinfo
 */
export function appInfo(){
  return new Promise((resolve, reject)=>{
    const serial = Date.now()
    window.appinfo_callback = function(result) {
      const res = JSON.parse(result)
      if(serial !== res.serial){
        return
      }
      resolve(res)
    }
    const os = isAndroidOrIos();
    const defaultInfo = {
      device: os, // 当前设备
      version: "", // app版本
      sdk_version: "1", // 最高支持sdk_version的版本号
      channel: "" // 渠道
    };
    if (os == 'android'&& window.hasOwnProperty('android')){
      if(typeof(eval(window.android.getAppInfo))=="function"){
        window.android.getAppInfo(JSON.stringify({ callback: 'appinfo_callback', serial: serial}))
      }else{
        // 版本为1
        resolve(defaultInfo)
      }
    } else if (os == 'ios' && window.webkit ){
      if(window.webkit.messageHandlers.getAppInfo){
        window.webkit.messageHandlers.getAppInfo.postMessage(JSON.stringify({ callback: 'appinfo_callback', serial: serial}));
      } else {
        // 版本为1
        resolve(defaultInfo)
      }
    }else{
      reject(new Error("不存在appinfo_callback"))
    }
  })
}

/**
 * 设置页面头
 * @param {string} title 
 * @param {object} operations 
 * {
 *    "color": "", // 标题栏的标题字体的颜色值（如：#ffffff）
 *    "background": "", // 标题栏的背景色
 *    "backable": "", // 是否需要返回按钮
 *    "showable": boolean, // 是否显示标题栏
 * }
 */
export function setTitle(title, operations){
  title = substring(title, 5, true)
  const os = isAndroidOrIos()
  if (os == 'android'&& window.hasOwnProperty('android')){
    if(typeof(eval(window.android.setViewTitle))=="function"){
      window.android.setViewTitle(JSON.stringify(Object.assign({title: title}, operations)))
    }
    if(typeof(eval(window.android.setTitle))=="function"){
      window.android.setTitle(title)
    }
  } else if(os == 'ios' && window.webkit && window.webkit.messageHandlers.setViewTitle){
    window.webkit.messageHandlers.setViewTitle.postMessage(JSON.stringify(Object.assign({title: title}, operations)))
  }
}
/**
 * 
 * @param {string} path 地址
 * @param {Object} data 携带参数
 * @param {string} ext  如何果目标页面为webkit则，将此参数值追加在链接下（作为透传参数），其余页面忽略
 */
export function appRedirect(path, data, ext, sdk_version) {
  const os = isAndroidOrIos()
  if (os == 'android'&& window.hasOwnProperty('android')&&typeof(eval(window.android.viewRedirect))=="function"){
    window.android.viewRedirect(JSON.stringify({path: path, data: data, ext: ext}))
  } else if(os == 'ios' && window.webkit && window.webkit.messageHandlers.setViewTitle){
    window.webkit.messageHandlers.viewRedirect.postMessage(JSON.stringify({path: path, data: data, ext: ext}))
  }
}
/**
 * 播放广告视频
 */
export function playAdVideo() {
  const os = isAndroidOrIos()
  if(os == 'android' && window.android && window.android.startAdPlay){
    window.android.startAdPlay()
    return true
  } else if(os == 'ios' && window.webkit && window.webkit.messageHandlers.startAdPlay){
    window.webkit.messageHandlers.startAdPlay.postMessage('');
    return true
  }

  return false
}